import ApiService from '../../../services/api.service'

export default {
    list(context, params) {
        const { sort, page, rowsPerPage, filter } = params ? params : [null, null, null, null]

        return new Promise((resolve, reject) => {
            ApiService.get('/admin/coupon', {
                sort,
                page,
                rowsPerPage,
                filter
            })
                .then(({ data }) => {
                    context.commit('setList', data)
                    resolve(data)
                })
                .catch(({ response }) => {
                    reject(response)
                })
        })
    },
    get(context, couponId) {
        return new Promise((resolve, reject) => {
            ApiService.get('/admin/coupon/' + couponId)
                .then(({ data }) => {
                    resolve(data)
                })
                .catch(({ response }) => {
                    reject(response)
                })
        })
    },
    create(context, model) {
        return new Promise((resolve, reject) => {
            ApiService.post('/admin/coupon', model)
                .then(data => {
                    resolve(data)
                })
                .catch(({ response }) => {
                    reject(response)
                })
        })
    },

    update(context, model) {
        return new Promise((resolve, reject) => {
            ApiService.put('/admin/coupon/' + model.id, model)
                .then(data => {
                    resolve(data)
                })
                .catch(({ response }) => {
                    reject(response)
                })
        })
    },

    delete(context, couponId) {
        return new Promise((resolve, reject) => {
            ApiService.delete('/admin/coupon/' + couponId)
                .then(({ data }) => {
                    resolve(data)
                })
                .catch(({ response }) => {
                    reject(response)
                })
        })
    }
}
